export class GdsgRegisteredWorker {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "stage",
            "baseName": "stage",
            "type": "string",
            "format": ""
        },
        {
            "name": "workerId",
            "baseName": "workerId",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastSeenMs",
            "baseName": "lastSeenMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "draining",
            "baseName": "draining",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "drainRequested",
            "baseName": "drainRequested",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgRegisteredWorker.attributeTypeMap;
    }
    constructor() {
    }
}
